//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class CartClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 创建购物车
     * @param api_version (optional) 
     */
    createCart(request: CreateFoodCartRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/cart?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processCreateCart(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 向购物车添加商品
     * @param api_version (optional) 
     */
    addCartItem(request: AddFoodCartItemRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/cart/item?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCartItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCartItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processAddCartItem(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新购物车的商品数据
     * @param api_version (optional) 
     */
    updateCartItem(request: UpdateFoodCartItemRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/cart/item?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCartItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCartItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processUpdateCartItem(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除购物车中的商品
     * @param api_version (optional) 
     */
    deleteCartItem(storeId: number, cartItemId: string, api_version?: string | null | undefined): Observable<SwaggerResponse<DeleteFoodCartItemResponse>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/cart/item/{storeId}/{cartItemId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (cartItemId === undefined || cartItemId === null)
            throw new Error("The parameter 'cartItemId' must be defined.");
        url_ = url_.replace("{cartItemId}", encodeURIComponent("" + cartItemId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCartItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCartItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DeleteFoodCartItemResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DeleteFoodCartItemResponse>>;
        }));
    }

    protected processDeleteCartItem(response: HttpResponseBase): Observable<SwaggerResponse<DeleteFoodCartItemResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFoodCartItemResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DeleteFoodCartItemResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 用户扫描二维码登录购物车
     * @param api_version (optional) 
     */
    loginDeliOrdering(request: LoginFoodCartRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<CustomerResponse>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/cart/login?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginDeliOrdering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginDeliOrdering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse>>;
        }));
    }

    protected processLoginDeliOrdering(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 将购物车分配给客户
     * @param api_version (optional) 
     */
    assignCartToCustomer(request: AssignCartToCustomerRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/cart/assign-cart-to-customer?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCartToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCartToCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processAssignCartToCustomer(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class CategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取所有分类
     * @param storeId (optional) 
     * @param languageCode (optional) 
     * @param api_version (optional) 
     */
    getCategorys(storeId?: number | undefined, languageCode?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCategoryDto[]>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCategoryDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCategoryDto[]>>;
        }));
    }

    protected processGetCategorys(response: HttpResponseBase): Observable<SwaggerResponse<FoodCategoryDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCategoryDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class ItemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取所有分类下的商品
     * @param storeId (optional) 
     * @param foodCategoryId (optional) 
     * @param languageCode (optional) 
     * @param api_version (optional) 
     */
    getFoodItems(storeId?: number | undefined, foodCategoryId?: string | undefined, languageCode?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodItemDto[]>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/item?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (foodCategoryId === null)
            throw new Error("The parameter 'foodCategoryId' cannot be null.");
        else if (foodCategoryId !== undefined)
            url_ += "foodCategoryId=" + encodeURIComponent("" + foodCategoryId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDto[]>>;
        }));
    }

    protected processGetFoodItems(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getFoodItemDetails(storeId?: number | undefined, itemId?: string | undefined, languageCode?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodItemDetailsDto>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/item/details?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItemDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItemDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDetailsDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDetailsDto>>;
        }));
    }

    protected processGetFoodItemDetails(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDetailsDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodItemDetailsDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDetailsDto>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class LanguageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getLanguages(storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<DeliOrderingLanguageDto[]>> {
        let url_ = this.baseUrl + "/api/deliordering-backend/food/language/languages?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DeliOrderingLanguageDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DeliOrderingLanguageDto[]>>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<SwaggerResponse<DeliOrderingLanguageDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliOrderingLanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DeliOrderingLanguageDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class OrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    createOrder(storeId: number, cartId: string, api_version?: string | null | undefined): Observable<SwaggerResponse<TransactionOrderResponse>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/order/{storeId}/{cartId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (cartId === undefined || cartId === null)
            throw new Error("The parameter 'cartId' must be defined.");
        url_ = url_.replace("{cartId}", encodeURIComponent("" + cartId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TransactionOrderResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TransactionOrderResponse>>;
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<SwaggerResponse<TransactionOrderResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionOrderResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TransactionOrderResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 前台打印完成，通知后厨
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    notifyKitchenPrintReady(response: TransactionOrderResponse, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/order/notify-kitchen-print-ready?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyKitchenPrintReady(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyKitchenPrintReady(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processNotifyKitchenPrintReady(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    getExternalTransactionFilesSource(api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/deliordering-frontend/food/order/source?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalTransactionFilesSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalTransactionFilesSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetExternalTransactionFilesSource(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

export class FoodCartResponse implements IFoodCartResponse {
    cart?: FoodCart | undefined;
    item?: FoodCartItem | undefined;

    constructor(data?: IFoodCartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? FoodCart.fromJS(_data["cart"]) : <any>undefined;
            this.item = _data["item"] ? FoodCartItem.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FoodCartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFoodCartResponse {
    cart?: FoodCart | undefined;
    item?: FoodCartItem | undefined;
}

export class FoodCart implements IFoodCart {
    id?: string;
    totalAmount?: number | undefined;
    totalTaxAmount?: number | undefined;
    accountNumber?: string;

    constructor(data?: IFoodCart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.totalAmount = _data["totalAmount"];
            this.totalTaxAmount = _data["totalTaxAmount"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): FoodCart {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalAmount"] = this.totalAmount;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IFoodCart {
    id?: string;
    totalAmount?: number | undefined;
    totalTaxAmount?: number | undefined;
    accountNumber?: string;
}

export class FoodCartItem implements IFoodCartItem {
    id?: string;
    card_ID?: string;
    foodItem_ID?: string;
    price?: number;
    quantity?: number;
    subtotal?: number;
    taxAmount?: number;
    selectedAttibutes?: ProductAttributeItem[];
    createdTime?: Date;
    memo?: string | undefined;

    constructor(data?: IFoodCartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.card_ID = _data["card_ID"];
            this.foodItem_ID = _data["foodItem_ID"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.subtotal = _data["subtotal"];
            this.taxAmount = _data["taxAmount"];
            if (Array.isArray(_data["selectedAttibutes"])) {
                this.selectedAttibutes = [] as any;
                for (let item of _data["selectedAttibutes"])
                    this.selectedAttibutes!.push(ProductAttributeItem.fromJS(item));
            }
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.memo = _data["memo"];
        }
    }

    static fromJS(data: any): FoodCartItem {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["card_ID"] = this.card_ID;
        data["foodItem_ID"] = this.foodItem_ID;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["subtotal"] = this.subtotal;
        data["taxAmount"] = this.taxAmount;
        if (Array.isArray(this.selectedAttibutes)) {
            data["selectedAttibutes"] = [];
            for (let item of this.selectedAttibutes)
                data["selectedAttibutes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["memo"] = this.memo;
        return data;
    }
}

export interface IFoodCartItem {
    id?: string;
    card_ID?: string;
    foodItem_ID?: string;
    price?: number;
    quantity?: number;
    subtotal?: number;
    taxAmount?: number;
    selectedAttibutes?: ProductAttributeItem[];
    createdTime?: Date;
    memo?: string | undefined;
}

export class ProductAttributeItem implements IProductAttributeItem {
    id?: string;
    name?: string | undefined;
    price?: number;

    constructor(data?: IProductAttributeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ProductAttributeItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        return data;
    }
}

export interface IProductAttributeItem {
    id?: string;
    name?: string | undefined;
    price?: number;
}

export class CreateFoodCartRequest implements ICreateFoodCartRequest {
    storeId?: number;
    accountNumber?: string | undefined;
    foodCartItem?: InsertFoodCartItemBody | undefined;

    constructor(data?: ICreateFoodCartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.accountNumber = _data["accountNumber"];
            this.foodCartItem = _data["foodCartItem"] ? InsertFoodCartItemBody.fromJS(_data["foodCartItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFoodCartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFoodCartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["accountNumber"] = this.accountNumber;
        data["foodCartItem"] = this.foodCartItem ? this.foodCartItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFoodCartRequest {
    storeId?: number;
    accountNumber?: string | undefined;
    foodCartItem?: InsertFoodCartItemBody | undefined;
}

export class InsertFoodCartItemBody implements IInsertFoodCartItemBody {
    foodItem_ID?: string;
    price?: number;
    quantity?: number;
    memo?: string | undefined;
    /** 选择的商品属性组 */
    selectedAttibutes?: ProductAttributeItem[];

    constructor(data?: IInsertFoodCartItemBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodItem_ID = _data["foodItem_ID"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.memo = _data["memo"];
            if (Array.isArray(_data["selectedAttibutes"])) {
                this.selectedAttibutes = [] as any;
                for (let item of _data["selectedAttibutes"])
                    this.selectedAttibutes!.push(ProductAttributeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertFoodCartItemBody {
        data = typeof data === 'object' ? data : {};
        let result = new InsertFoodCartItemBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodItem_ID"] = this.foodItem_ID;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["memo"] = this.memo;
        if (Array.isArray(this.selectedAttibutes)) {
            data["selectedAttibutes"] = [];
            for (let item of this.selectedAttibutes)
                data["selectedAttibutes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInsertFoodCartItemBody {
    foodItem_ID?: string;
    price?: number;
    quantity?: number;
    memo?: string | undefined;
    /** 选择的商品属性组 */
    selectedAttibutes?: ProductAttributeItem[];
}

export class AddFoodCartItemRequest implements IAddFoodCartItemRequest {
    storeId?: number;
    cartId?: string;
    foodCartItem?: InsertFoodCartItemBody | undefined;

    constructor(data?: IAddFoodCartItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.cartId = _data["cartId"];
            this.foodCartItem = _data["foodCartItem"] ? InsertFoodCartItemBody.fromJS(_data["foodCartItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddFoodCartItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddFoodCartItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["cartId"] = this.cartId;
        data["foodCartItem"] = this.foodCartItem ? this.foodCartItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddFoodCartItemRequest {
    storeId?: number;
    cartId?: string;
    foodCartItem?: InsertFoodCartItemBody | undefined;
}

export class UpdateFoodCartItemRequest implements IUpdateFoodCartItemRequest {
    storeId?: number;
    cartItemId?: string;
    quantity?: number;
    price?: number;
    memo?: string | undefined;
    /** 选择的商品属性组 */
    selectedAttibutes?: ProductAttributeItem[];

    constructor(data?: IUpdateFoodCartItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.cartItemId = _data["cartItemId"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.memo = _data["memo"];
            if (Array.isArray(_data["selectedAttibutes"])) {
                this.selectedAttibutes = [] as any;
                for (let item of _data["selectedAttibutes"])
                    this.selectedAttibutes!.push(ProductAttributeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFoodCartItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFoodCartItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["cartItemId"] = this.cartItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["memo"] = this.memo;
        if (Array.isArray(this.selectedAttibutes)) {
            data["selectedAttibutes"] = [];
            for (let item of this.selectedAttibutes)
                data["selectedAttibutes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateFoodCartItemRequest {
    storeId?: number;
    cartItemId?: string;
    quantity?: number;
    price?: number;
    memo?: string | undefined;
    /** 选择的商品属性组 */
    selectedAttibutes?: ProductAttributeItem[];
}

export class DeleteFoodCartItemResponse implements IDeleteFoodCartItemResponse {
    cart?: FoodCart | undefined;

    constructor(data?: IDeleteFoodCartItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? FoodCart.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteFoodCartItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFoodCartItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteFoodCartItemResponse {
    cart?: FoodCart | undefined;
}

export class Response implements IResponse {
    responseType?: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseType = _data["responseType"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseType"] = this.responseType;
        return data;
    }
}

export interface IResponse {
    responseType?: string | undefined;
}

export class CustomerResponse extends Response implements ICustomerResponse {
    customer?: CustomerDto | undefined;

    constructor(data?: ICustomerResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerResponse extends IResponse {
    customer?: CustomerDto | undefined;
}

export class CustomerDto implements ICustomerDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    cellphone?: string | undefined;
    tellphone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    createdDate?: Date | undefined;
    birthday?: Date | undefined;
    lastVisit?: Date | undefined;
    cardNumberForPos?: string | undefined;
    mergedto?: string | undefined;
    pointBalance?: number | undefined;
    customerLevel?: number | undefined;
    discountCode?: string | undefined;
    memo?: string | undefined;
    inactive?: boolean | undefined;
    loyaltyExcluded?: boolean | undefined;
    managerNeeded?: boolean | undefined;
    oneTimeDiscount?: boolean | undefined;
    taxExempt?: boolean | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.cellphone = _data["cellphone"];
            this.tellphone = _data["tellphone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipcode = _data["zipcode"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? new Date(_data["birthday"].toString()) : <any>undefined;
            this.lastVisit = _data["lastVisit"] ? new Date(_data["lastVisit"].toString()) : <any>undefined;
            this.cardNumberForPos = _data["cardNumberForPos"];
            this.mergedto = _data["mergedto"];
            this.pointBalance = _data["pointBalance"];
            this.customerLevel = _data["customerLevel"];
            this.discountCode = _data["discountCode"];
            this.memo = _data["memo"];
            this.inactive = _data["inactive"];
            this.loyaltyExcluded = _data["loyaltyExcluded"];
            this.managerNeeded = _data["managerNeeded"];
            this.oneTimeDiscount = _data["oneTimeDiscount"];
            this.taxExempt = _data["taxExempt"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["cellphone"] = this.cellphone;
        data["tellphone"] = this.tellphone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipcode"] = this.zipcode;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : <any>undefined;
        data["cardNumberForPos"] = this.cardNumberForPos;
        data["mergedto"] = this.mergedto;
        data["pointBalance"] = this.pointBalance;
        data["customerLevel"] = this.customerLevel;
        data["discountCode"] = this.discountCode;
        data["memo"] = this.memo;
        data["inactive"] = this.inactive;
        data["loyaltyExcluded"] = this.loyaltyExcluded;
        data["managerNeeded"] = this.managerNeeded;
        data["oneTimeDiscount"] = this.oneTimeDiscount;
        data["taxExempt"] = this.taxExempt;
        return data;
    }
}

export interface ICustomerDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    cellphone?: string | undefined;
    tellphone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    createdDate?: Date | undefined;
    birthday?: Date | undefined;
    lastVisit?: Date | undefined;
    cardNumberForPos?: string | undefined;
    mergedto?: string | undefined;
    pointBalance?: number | undefined;
    customerLevel?: number | undefined;
    discountCode?: string | undefined;
    memo?: string | undefined;
    inactive?: boolean | undefined;
    loyaltyExcluded?: boolean | undefined;
    managerNeeded?: boolean | undefined;
    oneTimeDiscount?: boolean | undefined;
    taxExempt?: boolean | undefined;
}

export class LoginFoodCartRequest implements ILoginFoodCartRequest {
    cartID?: string | undefined;
    storeId!: number;
    accountNumber?: string | undefined;

    constructor(data?: ILoginFoodCartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cartID = _data["cartID"];
            this.storeId = _data["storeId"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): LoginFoodCartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginFoodCartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartID"] = this.cartID;
        data["storeId"] = this.storeId;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface ILoginFoodCartRequest {
    cartID?: string | undefined;
    storeId: number;
    accountNumber?: string | undefined;
}

export class AssignCartToCustomerRequest implements IAssignCartToCustomerRequest {
    storeId!: number;
    cartID!: string;
    accountNumber!: string;

    constructor(data?: IAssignCartToCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.cartID = _data["cartID"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): AssignCartToCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCartToCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["cartID"] = this.cartID;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IAssignCartToCustomerRequest {
    storeId: number;
    cartID: string;
    accountNumber: string;
}

export class FoodCategoryDto implements IFoodCategoryDto {
    id?: string;
    name?: string | undefined;
    stortOrder?: number;
    parentId?: string | undefined;
    createDate?: Date | undefined;
    imagePath?: string | undefined;

    constructor(data?: IFoodCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stortOrder = _data["stortOrder"];
            this.parentId = _data["parentId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.imagePath = _data["imagePath"];
        }
    }

    static fromJS(data: any): FoodCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stortOrder"] = this.stortOrder;
        data["parentId"] = this.parentId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["imagePath"] = this.imagePath;
        return data;
    }
}

export interface IFoodCategoryDto {
    id?: string;
    name?: string | undefined;
    stortOrder?: number;
    parentId?: string | undefined;
    createDate?: Date | undefined;
    imagePath?: string | undefined;
}

export class FoodItemDto implements IFoodItemDto {
    id?: string;
    foodCategory_ID?: string | undefined;
    productDetails?: string | undefined;
    foodImagePath?: string | undefined;
    plU_ID?: string | undefined;
    barcode?: string | undefined;
    createDate?: Date | undefined;
    description?: string | undefined;
    price?: number | undefined;
    priceBase?: number | undefined;
    sortOrder?: number | undefined;
    is_Weight?: boolean;
    randomWeightPrice?: number | undefined;
    imagePath?: string | undefined;

    constructor(data?: IFoodItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.foodCategory_ID = _data["foodCategory_ID"];
            this.productDetails = _data["productDetails"];
            this.foodImagePath = _data["foodImagePath"];
            this.plU_ID = _data["plU_ID"];
            this.barcode = _data["barcode"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.price = _data["price"];
            this.priceBase = _data["priceBase"];
            this.sortOrder = _data["sortOrder"];
            this.is_Weight = _data["is_Weight"];
            this.randomWeightPrice = _data["randomWeightPrice"];
            this.imagePath = _data["imagePath"];
        }
    }

    static fromJS(data: any): FoodItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["foodCategory_ID"] = this.foodCategory_ID;
        data["productDetails"] = this.productDetails;
        data["foodImagePath"] = this.foodImagePath;
        data["plU_ID"] = this.plU_ID;
        data["barcode"] = this.barcode;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["price"] = this.price;
        data["priceBase"] = this.priceBase;
        data["sortOrder"] = this.sortOrder;
        data["is_Weight"] = this.is_Weight;
        data["randomWeightPrice"] = this.randomWeightPrice;
        data["imagePath"] = this.imagePath;
        return data;
    }
}

export interface IFoodItemDto {
    id?: string;
    foodCategory_ID?: string | undefined;
    productDetails?: string | undefined;
    foodImagePath?: string | undefined;
    plU_ID?: string | undefined;
    barcode?: string | undefined;
    createDate?: Date | undefined;
    description?: string | undefined;
    price?: number | undefined;
    priceBase?: number | undefined;
    sortOrder?: number | undefined;
    is_Weight?: boolean;
    randomWeightPrice?: number | undefined;
    imagePath?: string | undefined;
}

/** FoodItem详细信息 */
export class FoodItemDetailsDto implements IFoodItemDetailsDto {
    /** 商品基本信息 */
    item?: FoodItemDto | undefined;
    /** 商品副图数组 */
    imageGallery?: string[];
    /** 商品属性组列表 */
    attributeGroup?: ProductAttributeGroupDto[];

    constructor(data?: IFoodItemDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? FoodItemDto.fromJS(_data["item"]) : <any>undefined;
            if (Array.isArray(_data["imageGallery"])) {
                this.imageGallery = [] as any;
                for (let item of _data["imageGallery"])
                    this.imageGallery!.push(item);
            }
            if (Array.isArray(_data["attributeGroup"])) {
                this.attributeGroup = [] as any;
                for (let item of _data["attributeGroup"])
                    this.attributeGroup!.push(ProductAttributeGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FoodItemDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodItemDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        if (Array.isArray(this.imageGallery)) {
            data["imageGallery"] = [];
            for (let item of this.imageGallery)
                data["imageGallery"].push(item);
        }
        if (Array.isArray(this.attributeGroup)) {
            data["attributeGroup"] = [];
            for (let item of this.attributeGroup)
                data["attributeGroup"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** FoodItem详细信息 */
export interface IFoodItemDetailsDto {
    /** 商品基本信息 */
    item?: FoodItemDto | undefined;
    /** 商品副图数组 */
    imageGallery?: string[];
    /** 商品属性组列表 */
    attributeGroup?: ProductAttributeGroupDto[];
}

export class ProductAttributeGroupDto implements IProductAttributeGroupDto {
    /** 组ID */
    id?: string;
    /** 商品ID */
    plU_ID?: string | undefined;
    /** 组描述 */
    description?: string | undefined;
    /** 最大选择数量 */
    maximumSelected?: number | undefined;
    /** 最小选择数量 */
    minimumSelected?: number | undefined;
    /** 组成员列表 */
    items?: ProductAttributeItemDto[];

    constructor(data?: IProductAttributeGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plU_ID = _data["plU_ID"];
            this.description = _data["description"];
            this.maximumSelected = _data["maximumSelected"];
            this.minimumSelected = _data["minimumSelected"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductAttributeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductAttributeGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plU_ID"] = this.plU_ID;
        data["description"] = this.description;
        data["maximumSelected"] = this.maximumSelected;
        data["minimumSelected"] = this.minimumSelected;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProductAttributeGroupDto {
    /** 组ID */
    id?: string;
    /** 商品ID */
    plU_ID?: string | undefined;
    /** 组描述 */
    description?: string | undefined;
    /** 最大选择数量 */
    maximumSelected?: number | undefined;
    /** 最小选择数量 */
    minimumSelected?: number | undefined;
    /** 组成员列表 */
    items?: ProductAttributeItemDto[];
}

export class ProductAttributeItemDto implements IProductAttributeItemDto {
    id?: string;
    name?: string | undefined;
    price?: number | undefined;
    productAttributeGroup_ID?: string;
    color?: string | undefined;
    /** 显示位置 */
    displayIndex?: number | undefined;
    /** 默认当前是否选中 */
    checkedByDefault?: number | undefined;
    instruction?: number | undefined;

    constructor(data?: IProductAttributeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.productAttributeGroup_ID = _data["productAttributeGroup_ID"];
            this.color = _data["color"];
            this.displayIndex = _data["displayIndex"];
            this.checkedByDefault = _data["checkedByDefault"];
            this.instruction = _data["instruction"];
        }
    }

    static fromJS(data: any): ProductAttributeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["productAttributeGroup_ID"] = this.productAttributeGroup_ID;
        data["color"] = this.color;
        data["displayIndex"] = this.displayIndex;
        data["checkedByDefault"] = this.checkedByDefault;
        data["instruction"] = this.instruction;
        return data;
    }
}

export interface IProductAttributeItemDto {
    id?: string;
    name?: string | undefined;
    price?: number | undefined;
    productAttributeGroup_ID?: string;
    color?: string | undefined;
    /** 显示位置 */
    displayIndex?: number | undefined;
    /** 默认当前是否选中 */
    checkedByDefault?: number | undefined;
    instruction?: number | undefined;
}

export class DeliOrderingLanguageDto implements IDeliOrderingLanguageDto {
    code?: string | undefined;
    name?: string | undefined;
    sort?: number;

    constructor(data?: IDeliOrderingLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): DeliOrderingLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliOrderingLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["sort"] = this.sort;
        return data;
    }
}

export interface IDeliOrderingLanguageDto {
    code?: string | undefined;
    name?: string | undefined;
    sort?: number;
}

export class TransactionOrderResponse implements ITransactionOrderResponse {
    /** 交易ID */
    transactionID?: string | undefined;
    /** 交易时间 */
    transactionDate?: Date;
    /** 未含税总额 */
    subtotal?: number;
    /** 商品总数量 */
    totalQuantity?: number;
    /** 总税额 */
    totalTaxAmount?: number;
    /** 含税总额 */
    totalAmount?: number;
    /** 当天订单号 */
    dailyTrxNumber?: number;
    products?: Product[];

    constructor(data?: ITransactionOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionID = _data["transactionID"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.subtotal = _data["subtotal"];
            this.totalQuantity = _data["totalQuantity"];
            this.totalTaxAmount = _data["totalTaxAmount"];
            this.totalAmount = _data["totalAmount"];
            this.dailyTrxNumber = _data["dailyTrxNumber"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionID"] = this.transactionID;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["subtotal"] = this.subtotal;
        data["totalQuantity"] = this.totalQuantity;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["totalAmount"] = this.totalAmount;
        data["dailyTrxNumber"] = this.dailyTrxNumber;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ITransactionOrderResponse {
    /** 交易ID */
    transactionID?: string | undefined;
    /** 交易时间 */
    transactionDate?: Date;
    /** 未含税总额 */
    subtotal?: number;
    /** 商品总数量 */
    totalQuantity?: number;
    /** 总税额 */
    totalTaxAmount?: number;
    /** 含税总额 */
    totalAmount?: number;
    /** 当天订单号 */
    dailyTrxNumber?: number;
    products?: Product[];
}

export class Product implements IProduct {
    description?: string | undefined;
    pluId?: string | undefined;
    price?: number;
    quantity?: number;
    memo?: string | undefined;
    attributes?: ProductAttributeItem[] | undefined;
    attributesPre?: string[] | undefined;
    is_Weight?: boolean;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.pluId = _data["pluId"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.memo = _data["memo"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ProductAttributeItem.fromJS(item));
            }
            if (Array.isArray(_data["attributesPre"])) {
                this.attributesPre = [] as any;
                for (let item of _data["attributesPre"])
                    this.attributesPre!.push(item);
            }
            this.is_Weight = _data["is_Weight"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["pluId"] = this.pluId;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["memo"] = this.memo;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.attributesPre)) {
            data["attributesPre"] = [];
            for (let item of this.attributesPre)
                data["attributesPre"].push(item);
        }
        data["is_Weight"] = this.is_Weight;
        return data;
    }
}

export interface IProduct {
    description?: string | undefined;
    pluId?: string | undefined;
    price?: number;
    quantity?: number;
    memo?: string | undefined;
    attributes?: ProductAttributeItem[] | undefined;
    attributesPre?: string[] | undefined;
    is_Weight?: boolean;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}